var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader-wrapper"}},[_c('div',{attrs:{"id":"loader"}}),_c('div',{staticClass:"loader-section section-left"}),_c('div',{staticClass:"loader-section section-right"}),_c('div',{attrs:{"id":"loader-text"}},[_vm._v(" "+_vm._s(_vm.mensajeActual)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }